import { Box, Typography } from '@mui/material';
import React from 'react';
import { flexBase } from '../../Constants';

/**
 * Component that shows header data in a standardised format.
 */
export default ({ text, children }: IViewHeaderProps) => (
    <Box sx={{ ...flexBase, height: 48, px: 1, pt: 1 }}>
        <Typography
            variant='h5'
            sx={{
                flexGrow: 4,
                margin: 0,
            }}
        >
            {text}
        </Typography>
        {children}
    </Box>
);

/**
 * Interface that describes the configuration needed for the ViewHeader component.
 */
export interface IViewHeaderProps extends React.PropsWithChildren {
    /** Header text. */
    text: string | JSX.Element;
}
